import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
import { PlantDetails } from './PlantDetails';
import { ResultCard } from '../result-card';

export function PlantHistoryModal({ isOpen, onClose, plant }) {
  return (
    <AnimatePresence>
      {isOpen && plant && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4"
          onClick={onClose}
        >
          <motion.div
            initial={{ scale: 0.95, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0.95, opacity: 0 }}
            onClick={e => e.stopPropagation()}
            className="bg-white rounded-lg w-full max-w-2xl max-h-[90vh] overflow-y-auto"
          >
            <div className="sticky top-0 bg-white border-b p-4 flex items-center justify-between">
              <h2 className="text-xl font-semibold">Plant Details</h2>
              <button
                onClick={onClose}
                className="p-2 hover:bg-gray-100 rounded-full transition-colors"
              >
                <X className="w-5 h-5" />
              </button>
            </div>

            <div className="p-6 space-y-6">
              <img
                src={plant.imageUrl}
                alt="Plant"
                className="w-full h-48 object-cover rounded-lg"
              />
              <ResultCard plantName={plant.plantInfo} />
              <PlantDetails plantInfo={plant.plantInfo} />
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
